import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'usucampeao-allotment-unavailable',
  templateUrl: 'allotment-unavailable.modal.html',
  styleUrls: ['allotment-unavailable.modal.scss'],
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class AllotmentUnavailableModal {

  constructor(
    public modalController: ModalController,
    public router: Router,
  ) {}

  dismiss() {
    this.modalController.dismiss();
  }

  navigateTo(rota: string): void {
    this.dismiss();
    if (rota !== 'dismiss') {
      this.router.navigate([rota]);
    }
  }
}
